import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WithAuth from 'routes/AuthWrapper/WithAuth';
import { lazyWithReload } from '@/utils';
import EventDetail from '../EventDetail';
import EventsList from '../EventsList';

const Attendees = lazyWithReload(() => import('../Attendees'));
const AttendeeDetail = lazyWithReload(() => import('../AttendeeDetail'));
const Clients = lazyWithReload(() => import('../Clients'));
const ClientSettings = lazyWithReload(() => import('../ClientSettings'));
const Admins = lazyWithReload(() => import('../Admins'));
const AdminEdit = lazyWithReload(() => import('../AdminEdit'));
const DomainDetails = lazyWithReload(() => import('../DomainDetails'));
const Auth0Callback = lazyWithReload(() => import('../Auth0Callback'));

function RootRoutes() {
	return (
		<Suspense fallback={<div />}>
			<Routes>
				<Route path="/auth0callback" element={<Auth0Callback />} />
				<Route
					path="/events"
					element={
						<WithAuth permissive={true}>
							<EventsList />
						</WithAuth>
					}
				/>
				<Route
					path="/clients"
					element={
						<WithAuth>
							<Clients />
						</WithAuth>
					}
				/>
				<Route
					path="/clients/:clientID"
					element={
						<WithAuth>
							<ClientSettings />
						</WithAuth>
					}
				/>
				<Route
					path="/clients/:clientID/branding/:id"
					element={
						<WithAuth>
							<DomainDetails />
						</WithAuth>
					}
				/>
				<Route
					path="/admin/edit/:email"
					element={
						<WithAuth superOnly={true}>
							<AdminEdit />
						</WithAuth>
					}
				/>
				<Route
					path="/admins"
					element={
						<WithAuth superOnly={true}>
							<Admins />
						</WithAuth>
					}
				/>
				<Route
					path="/accounts"
					element={
						<WithAuth>
							<Attendees />
						</WithAuth>
					}
				/>
				<Route
					path="/accounts/:id"
					element={
						<WithAuth>
							<AttendeeDetail />
						</WithAuth>
					}
				/>
				<Route
					path="/events/:eventID/*"
					element={
						<WithAuth>
							<EventDetail />
						</WithAuth>
					}
				/>
				<Route path="/" element={<Navigate to="/events" replace />} />
			</Routes>
		</Suspense>
	);
}

export default RootRoutes;
